export const getInputValueOnChange = (e) => {
    return e?.target?.value
}